import { render, staticRenderFns } from "./ride-status-chip-field.vue?vue&type=template&id=ba1a3cf0"
import script from "./ride-status-chip-field.vue?vue&type=script&lang=js"
export * from "./ride-status-chip-field.vue?vue&type=script&lang=js"
import style0 from "./ride-status-chip-field.vue?vue&type=style&index=0&id=ba1a3cf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports